import tw, { styled } from 'twin.macro';

const OneThirdLayout = styled.div`
  ${tw`w-1/3 flex-none`}
`;

export default OneThirdLayout;
